import {AfterViewChecked, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ControlContainer, NgForm, NgModel} from '@angular/forms';

import {CountryCodeEnum} from '../../../enums/country-code.enum';
import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {IndustrySectorEnum} from '../../../enums/industry-sector.enum';
import {MyValuesChoicesModel} from '../../../models/my-values-choices.model';
import {ProjectEmployeeCountRangeEnum} from '../../../enums/project-employee-count-range.enum';
import {MyEditDialogStepsEnum} from '../../../enums/my-edit-dialog-steps.enum';
import {EnumUtils} from '../../../utils/enum.utils';

@Component({
    selector: 'app-projects-end-user-data-editor',
    templateUrl: './end-user-data-editor.component.html',
    styleUrls: ['./end-user-data-editor.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ProjectsEndUserDataEditorComponent extends EditModalSectionBaseComponent implements OnInit {

    @Input() public forceFormValidationVisibility: boolean;

    public selects = {
        'industrySector': new MyValuesChoicesModel(IndustrySectorEnum),
        'country': new MyValuesChoicesModel(CountryCodeEnum),
        'employeeCountRange': new MyValuesChoicesModel(ProjectEmployeeCountRangeEnum),
    };


    constructor(public  editModalService: EditModalService) {
        super(editModalService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
    }

    public getZipErrorMessages() {
        return {
            'pattern': 'Bitte geben Sie eine gültige PLZ ein.',
        };
    }


    onZipCodeChange(zipCodeNgModel: NgModel, countryNgModel: NgModel) {
        if (zipCodeNgModel.control.value.toString().match(/\d{4,5}/)) {
            if (zipCodeNgModel.control.value.length === 4) {
                this.model.project.company.country = EnumUtils.getKeyByValue(CountryCodeEnum, CountryCodeEnum.AT);
            }
            if (zipCodeNgModel.control.value.length === 5) {
                this.model.project.company.country = EnumUtils.getKeyByValue(CountryCodeEnum, CountryCodeEnum.DE);
            }
        }
        this.updateValidity(countryNgModel);
    }

    public zipEqualsToCountryTestFn = (value: string) => {

        // console.log('zipEqualsToCountryTestFn', value);

        if (this.model && this.model.project && this.model.project.company && this.model.project.company.zip) {
            const zipLength = this.model.project.company.zip.length;
            switch (CountryCodeEnum[value]) {
                case CountryCodeEnum.DE:
                    return zipLength === 5;
                case CountryCodeEnum.AT:
                    return zipLength === 4;
            }
        }
        return true;
    }

    updateValidity(ngModel: NgModel) {
        ngModel.control.updateValueAndValidity();
        // setTimeout(_ => {
        //     ngModel.control.updateValueAndValidity();
        // }, 0);
    }
}
